import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { walkmeUrl } from '../components/config/config';

/**
 * Tacking loader component.
 * Loads any tracking scripts like Walkme within the <head /> tags for the app.
 */
const TrackingLoader = () => {
    const { search } = useLocation();

    const disableTutorials = useMemo(() => {
        return new URLSearchParams(search).get('disableTutorials') === 'true';
    }, [search]);

    useEffect(() => {
        if (window && walkmeUrl) {
            // Configure Walkme only if Walkme is enabled
            window._walkmeConfig = { smartLoad: true };
        }
    }, []);

    return (
        <Helmet>
            {!disableTutorials && walkmeUrl && (
                <script id="walkme-script" type="text/javascript" async src={walkmeUrl} />
            )}
        </Helmet>
    );
};

export default TrackingLoader;
